firebird.factory('videoFaceTrackService', [
    '$interval',
    'logService',
    'configService',
    'videoGlobalService',
    function ($interval, logService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoFaceTrackService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            // face tracking related code

            self.faceTrack = false;
            self.faceTrackData = {
                // has overlap with self.videoFilter data.
                width: 1280,
                height: 720,
                frameRate: 30,
                //workerURL: '/lib/videobg/facetrack.js', // older JS library.
                workerURL: '/lib/videobg/worker-ft.js', // tensorflow based newer library.
                worker: null,
                pending: false,
                last: 0,
                minTime: 1000, // do not do more often than 1s
                minDiff: 200,
                minDiff2: 70, // min pixels change that calls for update. diff < h+w+2r or diff2 < r
                maxChange: 3, // number of pixels of max change per frame.

                facePosition: null, // last detected face.
                position: null, // current position
                factor: 0.05,

                canvasInput: null,
                canvasOutput: null,
                canvasStream: null,
                videoInput: null,
                videoStream: null
            };

            self.initFaceTrack = initFaceTrack;
            self.startFaceTrackStream = startFaceTrackStream;
            self.stopFaceTrackStream = stopFaceTrackStream;
        }

        // enable from config
        function initFaceTrack() {
            var faceTrack = configService.getClientValue('faceTrack');
            if (faceTrack && faceTrack != 'false') {
                self.faceTrack = faceTrack == 'true' ? true : faceTrack;
            }
        }

        function startFaceTrackStream() {
            if (!self.faceTrack) {
                return undefined;
            }

            var data = self.faceTrackData;

            // initialize positions and others
            data.facePosition = { cx: data.width / 2, cy: data.height / 2, r: Math.min(data.width, data.height) / 2 };
            data.position = JSON.parse(JSON.stringify(data.facePosition));
            data.factor = data.frameRate / 600; // so that it is not too quick.

            if (!data.worker) {
                data.worker = new Worker(data.workerURL);
                data.worker.addEventListener('message', function (event) {
                    if (!event.data || event.data.type != 'response') {
                        return;
                    }

                    var items = event.data.data;
                    var now = Date.now();

                    var data = self.faceTrackData;
                    var updated = 0,
                        delta = 0,
                        delta2 = 0;
                    if (items && items.length > 0) {
                        var rect = items[0];
                        var cx = rect.x + rect.width / 2;
                        var cy = rect.y + rect.height / 2;
                        var r = (rect.width + rect.height) / 2.3; // approx and padding
                        data.lastFace = { cx: cx, cy: cy, r: r };
                        delta =
                            Math.abs(data.facePosition.cx - cx) +
                            Math.abs(data.facePosition.cy - cy) +
                            2 * Math.abs(data.facePosition.r - r);
                        delta2 = Math.abs(data.facePosition.r - r);

                        if (delta >= data.minDiff || delta2 >= data.minDiff2) {
                            data.facePosition.cx = cx;
                            data.facePosition.cy = cy;
                            data.facePosition.r = r;
                            updated = true;
                        }
                    }

                    data.last = now;
                    data.pending = false;
                    // use console.info to avoid log entries, but display the performance locally.
                    console.info(
                        'ft-time=' +
                            (now - data.start) +
                            ' count=' +
                            (items && items.length) +
                            ' updated=' +
                            updated +
                            ' delta=' +
                            Math.round(delta) +
                            ' delta2=' +
                            Math.round(delta2)
                    );
                    //console.info('ft-pos=' + JSON.stringify(data.facePosition)); // used for debugging.
                });
            }

            if (!data.canvasStream) {
                var canvasInput = (data.canvasInput = document.createElement('canvas'));
                var canvasOutput = (data.canvasOutput = document.createElement('canvas'));
                var videoInput = (data.videoInput = document.createElement('video'));

                //document.body.appendChild(canvasInput);
                //canvasInput.setAttribute('style', 'position: fixed; z-index: 100; left: 0px; top: 0px; width: 320px; height: 180px;');

                videoInput.width = canvasOutput.width = canvasInput.width = data.width;
                videoInput.height = canvasOutput.height = canvasInput.height = data.height;
                videoInput.setAttribute('autoplay', true);
                videoInput.setAttribute('muted', true);

                data.canvasStream = canvasOutput.captureStream();

                var media = self.getMediaConstraints('video-filter');
                if (media.video) {
                    media.video.frameRate = Math.min(media.video.frameRate || 30, data.frameRate);
                    media.video.width = Math.min(media.video.width || 1280, data.width);
                    media.video.height = Math.min(media.video.height || 720, data.height);
                }
                navigator.mediaDevices
                    .getUserMedia(media)
                    .then(function (stream) {
                        self.faceTrackData.videoStream = stream;
                        stream.getVideoTracks()[0].contentHint = 'motion';
                        self.faceTrackData.videoInput.srcObject = stream;
                    })
                    .catch(function (err) {
                        logger.error('startFaceTrackStream', 'failed to get user media for face track', err);
                    });

                data.interval = $interval(function () {
                    var data = self.faceTrackData;
                    if (data.worker && data.videoInput && data.videoInput.videoWidth && data.videoInput.videoHeight) {
                        var now = Date.now();

                        if (!data.pending && data.last + data.minTime < now) {
                            data.pending = true;
                            data.start = now;

                            var ctx1 = data.canvasInput.getContext('2d');
                            ctx1.drawImage(data.videoInput, 0, 0, data.width, data.height);
                            var image = ctx1.getImageData(0, 0, data.width, data.height);
                            data.worker.postMessage(
                                {
                                    type: 'request',
                                    image: image.data.buffer,
                                    width: data.width,
                                    height: data.height
                                },
                                [image.data.buffer]
                            );
                        }

                        var ctx = data.canvasOutput.getContext('2d');
                        ctx.imageSmoothingEnabled = false;

                        var f = data.factor;
                        var cx0 = data.position.cx,
                            cy0 = data.position.cy,
                            r0 = data.position.r;
                        var cx = data.facePosition.cx * f + cx0 * (1 - f);
                        var cy = data.facePosition.cy * f + cy0 * (1 - f);
                        var r = data.facePosition.r * f + r0 * (1 - f);
                        if (cx > cx0 && cx > cx0 + data.maxChange) {
                            cx = cx0 + data.maxChange;
                        } else if (cx < cx0 && cx < cx0 - data.maxChange) {
                            cx = cx0 - data.maxChange;
                        }
                        if (cy > cy0 && cy > cy0 + data.maxChange) {
                            cy = cy0 + data.maxChange;
                        } else if (cy < cy0 && cy < cy0 - data.maxChange) {
                            cy = cy0 - data.maxChange;
                        }
                        if (r > r0 && r > r0 + data.maxChange) {
                            r = r0 + data.maxChange;
                        } else if (r < r0 && r < r0 - data.maxChange) {
                            r = r0 - data.maxChange;
                        }
                        r = data.position.r = Math.min(data.width / 2, data.height / 2, r);
                        cx = data.position.cx = Math.min(data.width - r, Math.max(r, cx));
                        cy = data.position.cy = Math.min(data.height - r, Math.max(r, cy));

                        if (data.last && data.last > now - 5000) {
                            ctx.filter = 'blur(3x)';
                        } else {
                            ctx.filter = 'none';
                        }

                        var h = Math.min(data.height, data.position.r * 2);
                        var w = Math.min(data.width, (h * data.width) / data.height);
                        var y = Math.max(0, Math.min(data.height - h, data.position.cy - h / 2));
                        var x = Math.max(0, Math.min(data.width - w, data.position.cx - w / 2));
                        if (self.faceTrack != 'debug') {
                            ctx.drawImage(data.videoInput, x, y, w, h, 0, 0, data.width, data.height);
                        } else {
                            // draw full image, and show face using circles.
                            ctx.drawImage(
                                data.videoInput,
                                0,
                                0,
                                data.width,
                                data.height,
                                0,
                                0,
                                data.width,
                                data.height
                            );

                            ctx.beginPath();
                            ctx.arc(cx, cy, r, 0, 2 * Math.PI, false);
                            ctx.lineWidth = 3;
                            ctx.strokeStyle = '#FFFF00';
                            ctx.stroke();

                            if (data.lastFace) {
                                ctx.beginPath();
                                ctx.arc(data.lastFace.cx, data.lastFace.cy, data.lastFace.r, 0, 2 * Math.PI, false);
                                ctx.lineWidth = 3;
                                ctx.strokeStyle = '#0000FF';
                                ctx.stroke();
                            }
                        }
                    }
                }, Math.round(1000 / data.frameRate));
            }
            return data.canvasStream.clone();
        }

        function stopFaceTrackStream() {
            logService.log('stopFaceTrackStream ...');

            var data = self.faceTrackData;
            if (data.interval) {
                $interval.cancel(data.interval);
                data.interval = null;
            }
            if (data.worker) {
                data.worker.terminate();
                data.worker = null;
            }
            if (data.canvasOutput) {
                data.canvasOutput = null;
            }
            if (data.videoInput) {
                data.videoInput.srcObject = null;
                data.videoInput = null;
            }
            if (data.canvasStream) {
                try {
                    data.canvasStream.getVideoTracks()[0].stop();
                } catch (e) {}
                data.canvasStream = null;
            }
            if (data.videoStream) {
                try {
                    data.videoStream.getVideoTracks()[0].stop();
                } catch (e) {}
                data.videoStream = null;
            }
            if (data.canvasInput) {
                data.canvasInput = null;
            }
            if (data.rect) {
                data.rect = null;
            }
        }
    }
]);
